jQuery(document).ready(function ($) {
	if ($('#form-home-1').length) {
		$(document).ready(function () {
			setTimeout(function () {
				let currentStep = 1;
				let formData = [];

				const stepsButton = $('.steps__item');
				const forms = $('.form__forms form');
				const hsForm1 = $('#form-home-1 .hs-form-iframe').contents().find('.hbspt-form form');
				const hsForm2 = $('#form-home-2 .hs-form-iframe').contents().find('.hbspt-form form');
				const hsForm3 = $('#form-home-3 .hs-form-iframe').contents().find('.hbspt-form form');
				const inputs1 = hsForm1.find('input');
				const selects1 = hsForm1.find('select');
				const inputs2 = hsForm2.find('input');
				const selects2 = hsForm2.find('select');
				const inputs3 = hsForm3.find('input');
				const selects3 = hsForm3.find('select');

				inputs1.css('border-radius', '10px');
				selects1.css('border-radius', '10px');
				inputs2.css('border-radius', '10px');
				selects2.css('border-radius', '10px');
				inputs3.css('border-radius', '10px');
				selects3.css('border-radius', '10px');
				inputs1.css('font-family', 'Poppins');
				inputs2.css('font-family', 'Poppins');
				inputs3.css('font-family', 'Poppins');
				selects1.css('font-family', 'Poppins');
				selects2.css('font-family', 'Poppins');
				selects3.css('font-family', 'Poppins');

				console.log({ hsForm1, hsForm2, hsForm3 });

				if (hsForm1.length && hsForm2.length && hsForm3.length) {
					$('.three-body').hide();
					$('#form-home-1').addClass('active');
				} else {
					window.location.reload();
				}

				hsForm1.submit(function () {
					const form = $(this);
					setTimeout(function () {
						const errors = form.find('.hs-error-msg').length;
						if (!errors) {
							showNextForm();
						}
					}, 1);
				});

				hsForm2.submit(function () {
					const form = $(this);
					setTimeout(function () {
						const errors = form.find('.hs-error-msg').length;
						if (!errors) {
							showNextForm();
						}
					}, 1);
				});

				hsForm3.submit(function () {
					const form = $(this);
					setTimeout(function () {
						const errors = form.find('.hs-error-msg').length;
					}, 1);
				});

				const submitButtons = $('.form__forms form button[type="submit"]');

				// stepsButton.click(function () {
				// 	const step = $(this).data('step');

				// 	if (step > currentStep) {
				// 		saveFormData(`#form-home-${currentStep}`);
				// 		let isValidForm = validateForm(formData, `#form-home-${currentStep}`);

				// 		if (isValidForm) {
				// 			showNextForm();
				// 		}
				// 	}

				// 	if (step < currentStep) {
				// 		currentStep = step;
				// 		forms.removeClass('active');
				// 		$(`#form-home-${currentStep}`).addClass('active');
				// 	}
				// });

				submitButtons.click(function (event) {
					event.preventDefault();
					const step = $(this).data('step');
					saveFormData(`#form-home-${step}`);
					let isValidForm = validateForm(formData, `#form-home-${currentStep}`);

					if (isValidForm) {
						showNextForm();
					}
				});

				function showNextForm() {
					currentStep++;
					$(`#step-item-${currentStep}`).addClass('showed');
					$(`#steps__item--before-${currentStep}`).addClass('showed');
					forms.removeClass('active');
					$(`#form-home-${currentStep}`).addClass('active');

					if (currentStep === 4) {
						fetchToHubSpot(formData);
					}
				}

				function saveFormData(formId) {
					$(formId).each(function () {
						$(this)
							.find('input, select, textarea')
							.each(function () {
								let inputData = {
									name: $(this)[0].name,
									type: $(this)[0].type,
									value:
										$(this)[0].type === 'checkbox' || $(this)[0].type === 'radio'
											? $(this)[0].checked
											: $(this)[0].value,
									field: $(this).data('field') ? $(this).data('field') : null,
									label: $(this)[0].type === 'radio' ? $(this)[0].value : null
								};

								if (formData.find((item) => item.name === inputData.name)) {
									const index = formData.findIndex((item) => item.name === inputData.name);

									if (formData[index].type === 'radio') {
										if (inputData.value === true) {
											formData[index] = inputData;
										}
									} else {
										formData[index] = inputData;
									}
								} else {
									formData.push(inputData);
								}
							});
					});
				}

				function validateForm(formData, formId) {
					let validForm = true;

					const formErrors = $('.form__error');
					formErrors.remove();

					formData.forEach((element) => {
						switch (element.type) {
							case 'text':
								if (!element.value) {
									validForm = false;
									$(`${formId} input[name="${element.name}"]`)
										.parent()
										.append('<p class="form__error">Este campo es requerido</p>');
								}
								break;

							case 'textarea':
								if (!element.value) {
									validForm = false;
									$(`${formId} textarea[name="${element.name}"]`)
										.parent()
										.append('<p class="form__error">Este campo es requerido</p>');
								}
								break;

							case 'number':
								if (!element.value) {
									validForm = false;
									$(`${formId} input[name="${element.name}"]`)
										.parent()
										.append('<p class="form__error">Este campo es requerido</p>');
								} else {
									if (element.value === '0') {
										validForm = false;
										$(`${formId} input[name="${element.name}"]`)
											.parent()
											.append('<p class="form__error">Ingrese un número diferente de cero</p>');
									}
								}
								break;

							case 'tel':
								if (!element.value) {
									validForm = false;
									$(`${formId} input[name="${element.name}"]`)
										.parent()
										.append('<p class="form__error">Este campo es requerido</p>');
								}
								break;

							case 'email':
								if (!element.value) {
									validForm = false;
									$(`${formId} input[name="${element.name}"]`)
										.parent()
										.append('<p class="form__error">Este campo es requerido</p>');
								} else {
									const emailPattern = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
									if (!emailPattern.test(element.value)) {
										validForm = false;
										$(`${formId} input[name="${element.name}"]`)
											.parent()
											.append('<p class="form__error">Ingrese un email válido</p>');
									}
								}
								break;

							case 'select-one':
								if (!element.value) {
									validForm = false;
									$(`${formId} select[name="${element.name}"]`)
										.parent()
										.append('<p class="form__error">Este campo es requerido</p>');
								}
								break;

							case 'radio':
								if (!element.value) {
									validForm = false;
									$(`${formId} input[name="${element.name}"][value="${element.label}"]`)
										.parent()
										.parent()
										.append('<p class="form__error">Este campo es requerido</p>');
								}
								break;

							default:
								break;
						}
					});

					return validForm;
				}

				function fetchToHubSpot(formData) {
					console.log(formData);
				}
			}, 2500);
		});
	}
});
